/**
 * Landing Page Component
 * Minimal landing page with logo and enter button only
 *
 * @module pages/LandingPage
 */

import { Link } from 'react-router-dom'
import { logger } from '@/utils/logger'
import { ROUTES } from '@/utils/constants'

/**
 * Landing page component
 * Displays only the walrus logo and enter button
 * No header, no footer, no distractions
 */
export default function LandingPage() {
  logger.debug('[WALRUS] LandingPage: rendering minimal landing page')

  return (
    <div className="min-h-screen bg-walrus-white flex flex-col items-center justify-center">
      {/* Logo */}
      <img
        src="/walrus-logo.png"
        alt="Rodrigo the Walrus"
        className="w-80 h-80 sm:w-[28rem] sm:h-[28rem] md:w-[36rem] md:h-[36rem] lg:w-[42rem] lg:h-[42rem] object-contain"
      />

      {/* Enter Button */}
      <Link
        to={ROUTES.LOGIN}
        className="mt-12 px-12 py-4 bg-walrus-black text-walrus-white font-bold text-xl tracking-widest rounded-lg hover:bg-walrus-charcoal transition-colors duration-200 shadow-lg hover:shadow-xl"
      >
        ENTER
      </Link>
    </div>
  )
}
